<template>
  <div>
    <v-list dense>
      <v-subheader v-if="!hasDocuments">No documents uploaded</v-subheader>
      <document v-for="document in documents" :document="document" :key="document.id"></document>
    </v-list>
    <multi-file-upload :customer="customer" :referral="referral" @uploaded="fileUploaded"></multi-file-upload>
    <uploaded-files @remove="fileRemove" v-if="newDocuments.length > 0" :documents="newDocuments"></uploaded-files>
  </div>
</template>

<script>
import _ from 'lodash';
import Document from './Document';
import MultiFileUpload from '../../../Referrals/Widgets/MultiFileUpload';
import UploadedFiles from '../../../Referrals/Widgets/UploadedFiles';

export default {
  components: { Document, MultiFileUpload, UploadedFiles },
  props: ['documents', 'customer', 'referral'],
  data: () => ({
    newDocuments: []
  }),
  name: 'document-list',
  computed: {
    hasDocuments() {
      return !_.isEmpty(this.documents);
    }
  },
  methods: {
    fileUploaded(url) {
      this.newDocuments.push(url);
    },
    fileRemove(index) {
      this.newDocuments.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
